import {
  Html5Qrcode,
  Html5QrcodeScanType,
  Html5QrcodeScannerState,
  Html5QrcodeSupportedFormats,
} from "html5-qrcode"
import { useEffect } from "react"
import "./html5-qrcode.css"
import { FacingMode } from "components/Scanner/type"

const qrcodeRegionId = "reader"

// Creates the configuration object for Html5QrcodeScanner.
const createConfig = (props) => {
  let config = {
    fps: 15,
    qrbox: null,
    aspectRatio: undefined,
    disableFlip: undefined,
    defaultZoomValueIfSupported: 1.7,
    showZoomSliderIfSupported: true,
    rememberLastUsedCamera: true,
    experimentalFeatures: {
      useBarCodeDetectorIfSupported: true,
    },
    supportedScanTypes: [Html5QrcodeScanType.SCAN_TYPE_CAMERA],
    formatsToSupport: [Html5QrcodeSupportedFormats.EAN_13],
  }
  if (props.fps) {
    config.fps = props.fps
  }
  if (props.qrbox !== undefined) {
    config.qrbox = props.qrbox
  }
  if (props.aspectRatio) {
    config.aspectRatio = props.aspectRatio
  }
  if (props.disableFlip !== undefined) {
    config.disableFlip = props.disableFlip
  }
  return config
}

const Html5QrcodePlugin = (props) => {
  useEffect(() => {
    if (!props.qrCodeSuccessCallback) {
      throw new Error("qrCodeSuccessCallback is required callback.")
    }

    const config = createConfig(props)
    const element = document.getElementById(qrcodeRegionId)
    if (!element) return

    const html5QrCode = new Html5Qrcode(qrcodeRegionId)
    Html5Qrcode.getCameras().then((devices) => {
      if (devices && devices.length) {
        let cameraId = null
        if (devices.length === 1) cameraId = devices[0].id
        if (devices.length > 1) {
          //check first for 2_0 camera as this is usally the default back one
          for (const device of devices) {
            const cameraLabel = device.label
            if (
              props.facingMode === FacingMode.USER &&
              cameraLabel &&
              cameraLabel.toLowerCase().includes("front")
            ) {
              cameraId = device.id
            } else if (
              cameraLabel &&
              cameraLabel.toLowerCase().includes("back") &&
              (cameraLabel.toLowerCase().includes("2 0") ||
                cameraLabel.toLowerCase().includes("2.0"))
            ) {
              // cameraId = device.id
            }
          }
          //if none is found take the first back one
          if (cameraId == null) {
            for (const device of devices) {
              const cameraLabel = device.label
              if (
                props.facingMode === FacingMode.USER &&
                cameraLabel &&
                cameraLabel.toLowerCase().includes("front")
              ) {
                cameraId = device.id
              } else if (
                props.facingMode === FacingMode.ENVIRONMENT &&
                cameraLabel &&
                cameraLabel.toLowerCase().includes("back")
              ) {
                cameraId = device.id
              }
            }
          }
        }
        if (cameraId == null) cameraId = devices[0].id

        html5QrCode
          .start(
            cameraId,
            config,
            props.qrCodeSuccessCallback,
            props.qrCodeErrorCallback
          )
          .catch((err) => {
            console.error(`Unable to start camera with ID ${cameraId}`, err)
          })

        const videoConfig = {
          advanced: [{ focusMode: "continuous" }, { zoom: 1.7 }],
        }
        startTimer(html5QrCode, videoConfig)
      }
    })

    return () => {
      html5QrCode.getState() === Html5QrcodeScannerState.SCANNING &&
        html5QrCode
          .stop()
          .then(() => {})
          .catch((error) => {
            console.error("Failed to stop html5QrCode.", error)
          })
    }
  }, [props])

  return (
    <div
      id={qrcodeRegionId}
      style={{
        width: "480px",
        height: "640px",
      }}
    />
  )
}

const startTimer = (html5QrCode, videoConfig) => {
  setTimeout(function () {
    const videoElement = document.querySelector("video")
    if (!videoElement) return

    if (html5QrCode.getState() === Html5QrcodeScannerState.SCANNING) {
      html5QrCode.applyVideoConstraints(videoConfig).catch((error) => {
        console.warn(
          "Video constraints not supported or failed to apply:",
          error
        )
      })
    } else {
      startTimer(html5QrCode, videoConfig)
    }
  }, 2000)
}

export default Html5QrcodePlugin
